import cookie from './cookie.js'
import storage from './storage.js'

/**
 * Determines if debug mode is enabled based on overrides and environment context.
 *
 * Precedence Order:
 * 1. storage ('debug' = 'true' || 'false')
 * 2. cookie ('debug=true' || 'debug=false')
 * 3. fallback: Default to true if environment is not 'prod'
 *
 * @param {string} [env='prod'] - The current environment (e.g., 'production', 'staging', 'development', 'test').
 * @returns {boolean} - True if debug mode is enabled, false otherwise.
 */
function resolveDebugValue(env = 'production') {
  const storageOverride = storage.getItem('debug')
  const cookieOverride = cookie.get('debug')
  const override = storageOverride ?? cookieOverride

  if (override !== null && override !== undefined) {
    return override === 'true' || override === '1'
  }

  return env !== 'production'
}

// Allow toggling debug mode directly from the browser console:
// e.g., type `setDebug(true)` in console
window.setDebug = (enable) => {
  if (enable === null) {
    storage.removeItem('debug')

    console.log('Cleared debug override. Reverting to environment default.')
  } else {
    storage.setItem('debug', enable ? 'true' : 'false')

    console.log(`Debug override set to: ${enable}`)
  }

  window.location.reload()
}

export default resolveDebugValue(window?.polyestershoppen?.config?.environment ?? 'production')
